<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="job">Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.job"
                        name="job"
                        id="job"
                        [itemsSource]="jobList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        [isEditable]="true"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="division">Division</label>
                    <input type="text" class="form-control" id="division" name="division" placeholder="Coming soon" disabled />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="eventDateTime">Date &amp; Time of Event</label>
                    <wj-input-date-time
                        [(ngModel)]="target.eventDateTime"
                        name="eventDateTime"
                        id="eventDateTime"
                        [isRequired]="false"
                    ></wj-input-date-time>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="employeeUserId">Employee</label>
                    <wj-combo-box
                        [(ngModel)]="target.employeeUserId"
                        name="employeeUserId"
                        id="employeeUserId"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="eventDescription">Event Description</label>
                    <textarea class="form-control" id="eventDescription" name="eventDescription" rows="2" [(ngModel)]="target.eventDescription"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="causes">Causes (Describe it)</label>
                    <textarea class="form-control" id="causes" name="causes" rows="2" [(ngModel)]="target.causes"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="correctiveActions">Corrective Actions Taken (if any)</label>
                    <textarea class="form-control" id="correctiveActions" name="correctiveActions" rows="2" [(ngModel)]="target.correctiveActions"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="reportedTo">Who was the Safety Feedback, Corrective Action or Near Miss Report to?</label>
                    <textarea class="form-control" id="reportedTo" name="reportedTo" rows="2" [(ngModel)]="target.reportedTo"></textarea>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="positiveFeedback">What positive feedback do you have?</label>
                    <textarea class="form-control" id="positiveFeedback" name="positiveFeedback" rows="2" [(ngModel)]="target.positiveFeedback"></textarea>
                </div>
            </div>
        </div>
        @if (canManageJha) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="requiresJha" name="requiresJha" [(ngModel)]="target.requiresJha" />
                            <label class="form-check-label" for="requiresJha">This feedback requires a Job Hazard Analysis</label>
                        </div>
                    </div>
                </div>
            </div>
            @if (target.requiresJha) {
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="d-block">JHA Status</label>
                            <span class="badge {{ jhaStatusClass }}">{{ jhaStatusLabel }}</span>
                            @if (target.linkedJobHazardAnalysisId && target.linkedJhaIndexId) {
                                <button type="button" class="btn btn-link p-0 ms-2 align-baseline" (click)="openLinkedJha()">Open JHA #{{ target.linkedJhaIndexId }}</button>
                            }
                        </div>
                    </div>
                </div>
                <div class="row align-items-end">
                    <div class="col-sm-6 col-12">
                        <div class="form-group">
                            <label for="linkedJha">Link to an existing JHA</label>
                            <wj-combo-box
                                [(ngModel)]="target.linkedJobHazardAnalysisId"
                                name="linkedJha"
                                id="linkedJha"
                                [itemsSource]="jhaList"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [isRequired]="false"
                                [isEditable]="false"
                            ></wj-combo-box>
                        </div>
                    </div>
                    <div class="col-sm-6 col-12">
                        @if (canCreateJha && !target.linkedJobHazardAnalysisId) {
                            <div class="form-group">
                                <button type="button" class="btn btn-outline-primary" (click)="createJha()" [disabled]="isCreatingJha || isSaving">
                                    @if (isCreatingJha) {
                                        <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Creating</span>
                                    } @else {
                                        <span>Create &amp; open JHA</span>
                                    }
                                </button>
                            </div>
                        }
                    </div>
                </div>
            }
        }
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label for="images-display">Images</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img style="width: 100%" [src]="'./Resources/Images/SafetyFeedback/' + url + '?w=300'" />
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label for="images-upload">Images To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Image(s)</button>
        <input style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" #fileInput multiple />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
